import  { TimeZoneArea } from './timezonearea';

export class Contact {

        public static readonly className:string = "com.tanzeel.common.vo.ContactVO";

        constructor(){}

        id: number;
        mobilePhone: string;
        alternateNumber: string;
        emailAddress: string;
        fbProfile: string;
        twitterHandle: string;
        addressLine1: string;
        addressLine2: string;
        postalCode: string;
        city: string;
        state: string;
        country: string;
        timeZoneStrId: string;
        timeZoneStr: TimeZoneArea;
        delete: boolean;

}
